<template>
    <div class="hs-container">
        <div class="handle-box">
            <div class="handle-left">
                <div class="search-left">
                    <el-select v-model="query.news_type" placeholder="订单类型" class="handle-input mr10">
                        <el-option v-for="item in planNewsTypeList" :key="item.id" :label="item.title" :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="query.company_id" placeholder="执行公司" filterable clearable class="handle-input mr10">
                        <el-option v-for="(item, index) in dictionary.getPicker('company')" :key="index" :label="item.title" :value="item.id+''"></el-option>
                    </el-select>
                    <el-date-picker class="daterange mr10" v-model="query.date_range" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    <el-select v-model="query.hotel_id" placeholder="举办酒店" class="handle-input mr10" filterable clearable>
                        <el-option v-for="(item, index) in dictionary.getPicker('hotel')" :key="index" :label="item.title" :value="item.id+''"></el-option>
                    </el-select>
                    <el-select v-model="query.planer_id" placeholder="请选择策划师" class="handle-input mr10" filterable clearable>
                        <el-option v-for="(item, index) in plannerList" :key="index" :label="item.realname" :value="item.id"></el-option>
                    </el-select>
                    <el-input v-model="query.keywords" placeholder="手机号/客户姓名/微信号" clearable class="handle-input mr10"></el-input>
                    <el-button type="primary" class="btn-search ml8" @click="changeHandler">搜索</el-button>
                    <el-popover placement="bottom" width="600" trigger="click">
                        <div class="help-container">
                            <div>
                                <el-tag type="danger">花艺单状态</el-tag>
                                <dl class="help-box">
                                    <dt class="w150">待申请:</dt>
                                    <dd>策划师未提交工程单</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt class="w150">工程单-待审核:</dt>
                                    <dd>策划师提交工程单，待审核</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt class="w150">工程单-审核中:</dt>
                                    <dd>策划师提交工程单，审核中</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt class="w150">工程单-驳回:</dt>
                                    <dd>策划师提交工程单，驳回</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt class="w150">待派发:</dt>
                                    <dd>最后批次工程单的派发状态</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt class="w150">部分派发:</dt>
                                    <dd>最后批次工程单的派发状态</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt class="w150">已完成:</dt>
                                    <dd>最后批次工程单的派发状态</dd>
                                </dl>
                            </div>
                        </div>
                        <el-button slot="reference" class="ml8" type="danger">注解</el-button>
                    </el-popover>
                </div>
            </div>
        </div>
        <!-- 搜索E -->

        <div class="table-box">
            <el-table :data="tableData" border :height="tableHeight" :max-height="tableHeight" v-loading="loading" @sort-change="sortChange">
                <el-table-column prop="planner[0].realname" label="策划师"></el-table-column>
                <el-table-column prop="service.title" label="执行公司"></el-table-column>
                <el-table-column prop="bridegroom" label="客户姓名"></el-table-column>
                <el-table-column prop="hotel" label="酒店" show-overflow-tooltip></el-table-column>
                <el-table-column prop="hall" label="厅" show-overflow-tooltip></el-table-column>
                <el-table-column prop="event_date" label="举办日期" align="center" sortable="custom"></el-table-column>
                <el-table-column prop="project" label="花艺单" align="center">
                    <template slot-scope="scope">
                        <el-link type="info" v-if="Object.keys(scope.row.project).length == 0">待申请</el-link>
                        <template v-if="scope.row.project.item_check_status!=2">
                            <el-link type="info" v-if="scope.row.project.item_check_status==0">工程单-待审核</el-link>
                            <el-link type="info" v-if="scope.row.project.item_check_status==1">工程审-核中</el-link>
                            <el-link type="info" v-if="scope.row.project.item_check_status==3">工程单-驳回</el-link>
                        </template>
                        <template v-else>
                            <el-button v-if="scope.row.project.item_check_status3==-1" type="primary" size="mini" @click="showDrawerPass(_self, 'planDetail', 'showDrawer', [scope.row.id])">待派发</el-button>
                            <el-button v-else type="primary" size="mini" @click="showDrawerPass(_self, 'planDetail', 'showDrawer', [scope.row.id])">已派发-{{getItemCheckTitle(scope.row.project.item_check_status3)}}</el-button>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column prop="project" label="工程单" align="center">
                    <template slot-scope="scope">
                        <el-link type="info" v-if="Object.keys(scope.row.project).length == 0">待申请</el-link>
                        <template v-else-if="scope.row.project.item_check_status!=2">
                            <el-link type="info" v-if="scope.row.project.item_check_status==0">工程单-待审核</el-link>
                            <el-link type="info" v-if="scope.row.project.item_check_status==1">工程单-审核中</el-link>
                            <el-link type="info" v-if="scope.row.project.item_check_status==3">工程单-驳回</el-link>
                        </template>
                        <template v-else>
                            <el-button v-if="scope.row.project.status == 0" type="primary" size="mini" @click="showDrawerPass(_self, 'projectDetail', 'showDrawer', [scope.row,'order'])">待分配</el-button>
                            <el-button v-if="scope.row.project.status == 1" type="success" size="mini" @click="showDrawerPass(_self, 'projectDetail', 'showDrawer', [scope.row,'order'])">部分分配</el-button>
                            <el-button v-if="scope.row.project.status == 2" type="warning" size="mini" @click="showDrawerPass(_self, 'projectDetail', 'showDrawer', [scope.row,'order'])">已完成</el-button>
                        </template>

                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 底部操作栏 -->
        <div class="footer-box">
            <div class="download"></div>
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[15, 20, 50, 100]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
            </div>
        </div>

        <plan-detail ref="planDetail" :parent="_self"></plan-detail>
        <project-detail ref="projectDetail" :parent="_self"></project-detail>
    </div>
</template>

<script>
import {
    showDrawerPass,
    getItemCheckTitle
} from '@/utils/common.js';
import dictionary from '@/utils/dictionary';
import planDetail from './detail.vue';
import projectDetail from '../../project/demand/detail.vue';

const query = {
    news_type: '1',
    company_id: "",
    hotel_id: "",
    planer_id: "",
    date_range: [],
    keywords: "", //手机号/客户姓名/微信号
};

export default {
    components: {
        planDetail,
        projectDetail
    },
    data() {
        let tableHeight = window.innerHeight - 252;
        let windowheight = window.innerHeight;
        return {
            plannerList: [],
            tableData: [],
            query: Object.assign({}, query), // 搜索条件
            tableHeight: tableHeight,
            windowheight: windowheight,
            pagination: {
                page: 1,
                limit: 15,
                totals: 0
            },
            loading: false,
            sort: {},
            router: ''
        };
    },
    computed: {
        planNewsTypeList() {
            let planList = [{
                id: "1",
                title: "婚庆信息"
            },
            {
                id: "7",
                title: "宝宝宴"
            },
            {
                id: "8",
                title: "会务"
            },
            {
                id: "11",
                title: "婚博会"
            },
            {
                id: "12",
                title: "婚礼秀"
            }
            ];

            return planList;
        }
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
        this.getItemCheckTitle = getItemCheckTitle;
        this.dictionary = dictionary;
    },
    created() {
        let _this = this;
        this.getTableData();
        if (this.$route.query.order_id) {
            let orderId = this.$route.query.order_id;
            let demandId = this.$route.query.demand_id; //
            let categoryId = this.$route.query.category_id; //
            let typeId = this.$route.query.m; //
            let ext = {
                order_id: orderId,
                demand_id: demandId,
                category_id: categoryId,
                m: typeId,
            }
            if (_this.$refs['planDetail']) {
                _this.$refs['planDetail'].showDialog(orderId, '', ext);
            } else {
                _this.$nextTick(function () {
                    _this.$refs['planDetail'].showDialog(orderId, '', ext);
                })
            }
        }
    },
    methods: {
        changeHandler() {
            this.pagination.page = 1;
            this.getTableData();
        },
        getTableData() {
            let _this = this;
            _this.loading = true;
            _this.router = _this.$route.path;
            let url = '/api/wedding.project/mine';
            let query = this.query;
            query['pagination'] = _this.pagination;
            query['sort'] = _this.sort;
            this.$post(url, query).then((res) => {
                _this.tableData = res.data.list;
                _this.pagination = res.data.pagination;
                _this.loading = false;
            });
        },
        // 排序
        sortChange(e) {
            if (e.order) {
                let sort = {};
                sort.field = e.prop;
                sort.order = e.order == 'descending' ? 'desc' : 'asc';
                this.sort = sort;
            } else {
                this.sort = {};
            }
            this.getTableData();
        },
        // 分页
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
        getStatus(status) {
            let title = '';
            switch (status) {
                case 0:
                    title = '待分配';
                    break;
                case 1:
                    title = '已派单';
                    break;
                case 2:
                    title = '分派中';
                    break;
                case 3:
                    title = '已完成';
                    break;
                case 4:
                    title = '已作废';
                    break;
                default:
                    title = '';
            }

            return title;
        },
        getPlannerList() {
            let _this = this;
            let url = '/api/ucenter.user/roleUserList';
            let params = {
                role_id: [32, 35]
            };
            _this.$post(url, params).then((res) => {
                _this.plannerList = res.data.list;
            });
        }
    }
};
</script>

<style lang="less">
@import url('@/assets/css/common.less');
</style>
